<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useContextDataStore } from '@/VueCore/stores/contextDataStore';
  import PortalSettingsProvider from '@/Utils/portalSettingsProvider';
  import { AccountType } from '@/Types/Enums/accountType';
  import NavBar from '@/VueComponents/SiteComponents/Navigation/NavBar.vue';

  const contextDataStore = useContextDataStore();
  const route = useRoute();

  const activeNavbarLink = computed(() => {
    const activeLink = '/' + route.path.split('/')[1];

    switch(activeLink) {
    case '/':
      return '/requests';
    case '/request':
      return '/requests'
    case '/uploadfolderdetails':
      return '/uploadfolders'
    default:
      return activeLink;
    }
  })

  const isBusinessAccountType = computed(() => PortalSettingsProvider.getAccountType() === AccountType.Business);
  const isPartnerAccountType = computed(() => PortalSettingsProvider.getAccountType() === AccountType.Partner);
  const isSelfResponsesAvailable = computed(() => PortalSettingsProvider.getSelfResponseEnabled());
  const isBusinessAdminUser = computed(() => contextDataStore.userData?.isBusinessAdminUser);
</script>

<template>
  <NavBar
    :items="[
      { link: '/requests', label: $localize('Requests') },
      { link: '/cameras', label: $localize('Cameras'), condition: isBusinessAccountType },
      { link: '/uploadfolders', label: $localize('UploadFolders'), condition: isPartnerAccountType && isSelfResponsesAvailable },
      { link: '/my-account', label: $localize('MyAccount') },
      { link: '/users', label: $localize('UsersTitle'), condition: isBusinessAdminUser },
      { link: '/groups', label: $localize('GroupsTitle'), condition: isBusinessAdminUser },
      ]"
    :active-link="activeNavbarLink"
  />
</template>